import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

export interface ILoadingParams {
  message?: string
  loading?: boolean
  animation?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private status: BehaviorSubject<boolean> = new BehaviorSubject(false)

  get status$(): Observable<boolean> {
    return this.status.asObservable()
  }

  setLoading(params: ILoadingParams = { loading: false }) {
    const { loading } = params
    if (typeof loading !== 'undefined') {
      this.status.next(loading)
    }
  }

  toggleStatus(value?: boolean) {
    if (typeof value !== 'undefined') {
      this.status.next(value)
    } else {
      const current = this.status.value
      this.status.next(!current)
    }
  }
}
